import { createFileRoute } from '@tanstack/react-router';
import { PageHeader, Stack } from '@leanin/ui';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';
import { BulkInviteClient } from './-BulkInviteClient';

export const Route = createFileRoute('/_authed/admin/invitations/bulk/')({
  component: AdminBulkInvitationsPage,
});

function AdminBulkInvitationsPage() {
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="invitations">
      <Stack gap="lg">
        <PageHeader
          back={{ label: 'Back to invitations', href: '/admin/invitations' }}
          title="Bulk invite"
          subtitle="Upload a CSV to invite multiple members in one batch. Each row produces one invitation; skipped rows are reported individually."
        />
        <BulkInviteClient />
      </Stack>
    </AdminShell>
  );
}
